export default () => {
  const $csrf = document.querySelector('meta[name="csrf-token"]')

  return $csrf ? $csrf.content : ''
}
